import PropTypes from "prop-types";
import teamList from "./teamList.json";
import {gameToWinRate} from "./elo";
import {useCxt} from "./StructureProvider"
import styles from "./game.module.css";
import global_styles from "./global.module.css";
import { useParams } from "react-router-dom";

// it's just a viewer.
function Game({ game, playSet, playGame, nextGame, playRound }) {	
	const {leagueElo} = useCxt();
	const {language} = useParams();
	
	const goal = (game.Bo + 1) / 2;
	const isDone = Number(game.score[0]) === goal || Number(game.score[2]) === goal;
	
	function viewBox(info) {
		const team1 = teamList[info.team1];
		const team2 = teamList[info.team2];
		console.log(team1, teamList, info.team1);
		const exWin = (gameToWinRate(info, leagueElo) * 100).toFixed(2);
		return (
			<div className={styles.viewBox}>
				<div className={styles.teamName}>
						{team1.team}
				</div>
				<div className={styles.newRow}>
					{language === "kr" ? "리그" : "league"}
				</div>
				<div>
					{language === "kr" ? "세트 승리확률" : "prob. of Winning a set"}
				</div>
				<div>
					{language === "kr" ? "점수" : "score"}
				</div>
				<div className={styles.newRow}>
						{team1.league}
				</div>
				<div>
					{exWin}%
				</div>
				<div>
					{info.score[0]}
				</div>
				
				<div className={styles.vs}>VS</div>
				<div className={styles.newRow}>Bo{info.Bo}</div>
				
				<div className={styles.teamName}>
					{team2.team}
				</div>
				<div className={styles.newRow}>
					{language === "kr" ? "리그" : "league"}
				</div>
				<div>
					{language === "kr" ? "세트 승리확률" : "prob. of Winning a set"}
				</div>
				<div>
					{language === "kr" ? "스코어" : "score"}
				</div>
				<div className={styles.newRow}>
					{team2.league}
				</div>
				<div>
					{(100 - exWin).toFixed(2)}%
				</div>
				<div>
					{info.score[2]}
				</div>
			</div>
		);
	}
	
	// if the game is done, don't show playSet and playGame button.
	// if playRound is undefined, don't show it.
	return(
		<div>
			<div className={global_styles.main_container}>{viewBox(game)}</div>
			<div className={global_styles.button_container}>
				{
					!isDone ?
					<>
						<button onClick={playSet}>
							play a set
						</button>
						<button onClick={playGame}>
							play a game
						</button>
					</> : <button onClick={nextGame}>next game</button>
				}
				{
					playRound !== undefined ?
					<button onClick={playRound}>
						skip round
					</button> : null
				}
			</div>
		</div>
	);
}

Game.propTypes = {
	stage: PropTypes.number,
	work: PropTypes.number,
	playSet: PropTypes.func,
	playGame: PropTypes.func,
	nextGame: PropTypes.func,
	playRound: PropTypes.func,
}

export default Game;